import cloneDeep from 'lodash/cloneDeep';

import { selectProfile } from '../profile/selectors';
import type { States } from '../states';

import type { MailSettings } from './mailing';
import { initialMailSettings } from './mailing';
import type { SettingsState } from './settings';

export const selectSettingsState = ({ Settings }: States): SettingsState => Settings;

export const selectMailSettings = (states: States): MailSettings => {
    const { mailSettings } = selectSettingsState(states);
    const profile = selectProfile(states);

    // Ядро отдаёт пустой массив, пока настройки ни разу не сохранялись —
    // приводим ответ к объекту, иначе Form3/immer падают на массиве
    const saved = Array.isArray(mailSettings) ? {} : cloneDeep(mailSettings);
    const ms: MailSettings = { ...initialMailSettings, ...saved };

    ms.email = ms.email || profile.email;
    // Настройки, сохранённые до появления переключателя «Авторизация», не содержат auth — считаем авторизацию включённой
    ms.auth = ms.auth ?? true;

    return ms;
};

export const selectSettingFetch = (states: States): boolean => {
    const s = selectSettingsState(states);

    return s.fetch;
};

export const selectUserChartsSettings = (states: States) => {
    const s = selectSettingsState(states);

    return s.charts;
};
